const pciRuntimeStateActions = {
    types: {
        PCI_RUNTIME_STATE_SET: 'PCI_RUNTIME_STATE_SET',
        PCI_RUNTIME_STATE_REMOVE: 'PCI_RUNTIME_STATE_REMOVE',
        PCI_RUNTIME_STATE_RESET: 'PCI_RUNTIME_STATE_RESET',
    },

    setPciRuntimeState(interactionUID, data) {
        return {
            type: this.types.PCI_RUNTIME_STATE_SET,
            interactionUID,
            data,
        };
    },

    removePciRuntimeState(interactionUID) {
        return {
            type: this.types.PCI_RUNTIME_STATE_REMOVE,
            interactionUID,
        };
    },

    resetPciRuntimeState() {
        return {
            type: this.types.PCI_RUNTIME_STATE_RESET,
        };
    },
};

export default pciRuntimeStateActions;
